//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PostComment } from "@/models"
import { mapMutations } from 'vuex'

export default {
  name: "jielongTopicReply",
  created() {
    // do something
  },
  props: ["reply"],
  data() {
    return {};
  },
  methods: {
    ...mapMutations(['setUserMsg']),
    commentHandler: function() {
      this.$emit("comment", this.comment);
    },
    deleteComment: function() {
      this.$vux.confirm.show({
        title: "操作提示",
        content: "确认删除？",
        onConfirm: () => {
          PostComment.delete(this.comment.objectId).then(() => {
            this.$emit("delete", this.comment);
          });
        }
      });
    },
    goToWork: function() {
      // this.$router.push({})
    },
    goToUserMsg () {
      this.setUserMsg(this.reply.get('user').toJSON())
      // this.$router.push({
      //   name: 'userMsg'
      // })
    }
  },
  components: {}
};



// WEBPACK FOOTER //
// ./src/components/topic_reply/JielongTopicReply.vue